import React, { useEffect, useState } from 'react'
import './nav-menu.scss'

const NavLink = ({ className, href, children, id, onClick }) => {
  return (
    <li className={'f-navMenu__list__item' + className}>
      <a
        onClick={onClick}
        href={href}
        tag="6A"
        className="  f-button --btn-url  "
        id={id}
      >
        {children}
      </a>
    </li>
  )
}
const NavMenu = ({ links = { home: '/' } }) => {
  const [hash, setHash] = useState('')
  const handlerLinkClick = evt => {}
  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }
    const onHashlistener = () => {
      setHash(window.location.hash)
      if (window.location.hash.length === 0) {
        return
      }
      let element = document.querySelector(window.location.hash)
      if (element) {
        document.scrollingElement.scroll(0, element.offsetTop - 60)
      }
    }
    const onScrollListener = () => {
      let is_mobile = window.innerWidth < 1024
      let hold = window.innerHeight < 800 && !is_mobile && window.scrollY > 120
      const dommenu = document.querySelector('.f-navMenu ')
      const max = 150
      const calculated = is_mobile ? max - dommenu.clientHeight : max

      let top = hold ? 0 : calculated
      dommenu.style.top = top + 'px'
      dommenu.style.position = window.scrollY > 10 ? 'fixed' : 'absolute'
    }
    window.addEventListener('hashchange', onHashlistener, false)
    window.addEventListener('scroll', onScrollListener, false)
    onHashlistener()
    onScrollListener()
    return () => {
      window.removeEventListener('hashchange', onHashlistener)
      window.removeEventListener('scroll', onScrollListener)
    }
  }, [])
  return (
    <nav className={'f-navMenu  '}>
      <ul className="f-navMenu__list">
        {Object.keys(links).map(key => {
          return (
            <NavLink
              className={hash === '#' + key ? ' --active' : ''}
              href={'#' + key}
              key={key}
              onClick={handlerLinkClick}
            >
              {links[key]}
            </NavLink>
          )
        })}
      </ul>
    </nav>
  )
}

export default NavMenu
